(() => {
  const root = document.documentElement;
  const navigationKey = 'lufasnd:navigation-entry';
  const newsletterKey = 'lufasnd:newsletter-submit';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let navigating = false;

  const storageGet = (key) => {
    try {
      return sessionStorage.getItem(key) === '1';
    } catch (_error) {
      return false;
    }
  };

  const storageSet = (key) => {
    try {
      sessionStorage.setItem(key, '1');
    } catch (_error) {
      // Continue when storage is unavailable.
    }
  };

  const storageRemove = (key) => {
    try {
      sessionStorage.removeItem(key);
    } catch (_error) {
      // Continue when storage is unavailable.
    }
  };

  const currentUrl = new URL(window.location.href);
  const isNewsletterResult =
    storageGet(newsletterKey) ||
    currentUrl.searchParams.get('customer_posted') === 'true';
  const isIncomingNavigation = storageGet(navigationKey) || isNewsletterResult;

  /* Apply the hidden entry state before DOMContentLoaded so the browser does
   * not briefly paint the footer anchor before the incoming fade begins. */
  if (isIncomingNavigation && !reduceMotion.matches) {
    root.classList.add('lufasnd-navigation-entry');
  }

  const cleanNewsletterUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('customer_posted');

    if (/newsletter|contact_form/i.test(url.hash)) {
      url.hash = '';
    }

    window.history.replaceState(
      {},
      document.title,
      `${url.pathname}${url.search}${url.hash}`
    );
  };

  const showNewsletterSuccess = () => {
    if (!isNewsletterResult || document.querySelector('[data-lufasnd-newsletter-toast]')) return;

    const toast = document.createElement('div');
    toast.className = 'lufasnd-newsletter-toast';
    toast.dataset.lufasndNewsletterToast = '';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = 'Thanks for subscribing.';
    document.body.appendChild(toast);

    requestAnimationFrame(() => toast.classList.add('is-visible'));

    window.setTimeout(() => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => toast.remove(), 220);
    }, 3600);
  };

  const revealIncomingPage = () => {
    if (!isIncomingNavigation) return;

    history.scrollRestoration = 'manual';

    if (isNewsletterResult) {
      cleanNewsletterUrl();
    }

    /* Newsletter submission should return to a normal page view rather than
     * allowing Shopify's #contact_form anchor to pin the viewport to footer. */
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    storageRemove(navigationKey);
    storageRemove(newsletterKey);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        root.classList.add('lufasnd-navigation-ready');
        showNewsletterSuccess();

        window.setTimeout(() => {
          root.classList.remove('lufasnd-navigation-entry', 'lufasnd-navigation-ready');
          history.scrollRestoration = 'auto';
        }, 320);
      });
    });
  };

  const startLeaving = (callback) => {
    if (reduceMotion.matches) {
      callback();
      return;
    }

    root.classList.add('lufasnd-navigation-leaving');
    window.setTimeout(callback, 180);
  };

  const shouldHandleLink = (event, link) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      !link ||
      link.target === '_blank' ||
      link.hasAttribute('download') ||
      link.dataset.noPageTransition !== undefined
    ) {
      return false;
    }

    const rawHref = link.getAttribute('href');
    if (!rawHref || rawHref.startsWith('#')) return false;
    if (/^(mailto:|tel:|javascript:)/i.test(rawHref)) return false;

    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin) return false;

    const current = new URL(window.location.href);
    const sameDocument =
      destination.pathname === current.pathname &&
      destination.search === current.search;

    if (sameDocument && destination.hash) return false;
    return true;
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const link = target?.closest('a[href]');
    if (!shouldHandleLink(event, link) || navigating) return;

    navigating = true;
    event.preventDefault();
    storageSet(navigationKey);

    const destination = new URL(link.href, window.location.href);
    const reloadCurrentPage = destination.href === window.location.href;

    startLeaving(() => {
      if (reloadCurrentPage) {
        window.location.reload();
      } else {
        window.location.assign(destination.href);
      }
    });
  });

  /* Newsletter forms deliberately use Shopify's native submission flow.
   * Intercepting them or calling form.submit() bypasses Shopify CAPTCHA. */

  /* Do not stack the manual fallback fade over the browser's native MPA
   * transition. */
  window.addEventListener('pageswap', (event) => {
    if (navigating) event.viewTransition?.skipTransition();
  });

  window.addEventListener('pageshow', () => {
    navigating = false;
    root.classList.remove('lufasnd-navigation-leaving');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealIncomingPage, { once: true });
  } else {
    revealIncomingPage();
  }
})();
